import React, { Component } from 'react';
import {Link}from 'react-router-dom';
import ReactDOM from 'react-dom';

// images

import InfoJumb1 from './images/infoJumbo1.jpg';
import InfoJumb2 from './images/infoJumbo2.jpg';
import InfoJumb3 from './images/infoJumbo3.jpg';

import banner1 from './images/banner1.jpg';

import {Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class Exeron extends Component {
  render() {
    var dataNews;
    var dataVideo;
    var builtTmpNews;
    var builtTmpVideos;
    var parseStringNews = require('xml2js').parseString;
    fetch('/newsData.xml')
    .then((r) => r.text())
    .then(text  => {
      parseStringNews(text, function (err, result) {
          dataNews=result;
          var tmpOV = JSON.parse(JSON.stringify(result));
          dataNews= tmpOV.NewsList.News;
          var newDataNews = [];
          for (var ele in dataNews) {
            if (dataNews[ele].Supplier[0].includes("exeron")){
              newDataNews.push(dataNews[ele]);
            }
          }
          dataNews = newDataNews;
          builtTmpNews = dataNews.map((element) =>
                <Col xs={12} sm={6} md={4} lg={3} className="newsItem">
                  <div className="newsCont news-supplier">
                    <img src={`../news/${element.Image}`} alt={element.Title} id={`image ${element.Title}`} className={`newsImg${element.classType}`} />
                    <video id="background-video" className={`newsVideo${element.classType}`} loop autoPlay id={`video ${element.Title}`} playsInLine="true">
                        <source src={`../videos/${element.FileShort}`} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    <h4>{element.Title}</h4>
                    <h5>{element.Supplier}</h5>
                    <hr/>
                    <p className="newsText">{element.Text}</p>
                    <hr/>
                    <p className="newsDate">{element.Date}</p>
                  </div>
                </Col>

              );
          }.bind(this));
          this.builtElement = ReactDOM.render(builtTmpNews, document.getElementById('newsRoot'));
      });
    return (
      <div className='container-fluid'>
        <div className="supMainLS">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/WuF">WuF</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>exeron</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt="exeron Headquater"/>
        </div>
        <div className="supMainTextLS">
          <h1>exeron</h1>
          <Grid className="supMainInfo">
          <Row>
            <Col xsHidden smHidden md={5}>
              <Carousel  controls={false} interval={3000}>
                <Carousel.Item >
                    <img  src={InfoJumb1}  alt="exeron Headquater"  height="100%" />
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb2} alt="exeron Produktion"  height="100%"/>
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb3} alt="exeron Erosion"  height="100%" />
                </Carousel.Item>
              </Carousel>
              </Col>
            <Col xsHidden md={7}>
              <h4>exeron versteht sich als Hersteller solider, zuverlässiger und langlebiger Erodiermaschinen (EDM) und Hochgeschwindigkeitsfräsmaschinen (HSC) sowie Handlingsystemen „Made in Germany“. Der Werkzeugmaschinen-Hersteller verbindet diese Kompetenz zu nachhaltigem Erfolg für seine Kunden.
exeron verfügt über eine stabile und verlässliche Gesellschafterstruktur, ein wertorientiertes Management und steht für Professionalität, Qualität, Kundenorientierung, Flexibilität und Servicekompetenz. exeron löst auch Ihr Erodierproblem. Schnell, individuell, kompetent und in enger Zusammenarbeit mit Ihnen. Mit dem Produktions-, Anwendungs- und Schulungszentrum in unserem Hauptsitz in Oberndorf sowie dem Servicestützpunkt in Wolfratshausen ist exeron verkehrsgünstig für Sie erreichbar. Jederzeit.
            </h4>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden>
              <h4>exeron versteht sich als Hersteller solider, zuverlässiger und langlebiger Erodiermaschinen (EDM) und Hochgeschwindigkeitsfräsmaschinen (HSC) sowie Handlingsystemen „Made in Germany“.
            </h4>
            </Col>
            <Col xs={12} md={{ span: 7, offset: 2 }}>
              <Button className="supMainButtonWebPage" variant="light" href="https://www.exeron.de/" rel="noopener" rel="noreferrer" target="_blank">Hersteller Homepage</Button>
            </Col>
          </Row>
        </Grid>
      </div>
        <br/>
        <section>
        <div className="supMainKeyWords">
          <br/>
          <Grid className="shortDesc">
            <Row>
              <Col xsHidden  sm={4} md={2}>

                <h5>Innovation Made in Germany</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                  <h5>40 Jahre Know-How</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Deutscher Servicestützpunkt</h5>
              </Col>

            </Row>
            <br/>
            <Row className="show-grid">
              <Col xs={12}  smHidden mdHidden lgHidden>

                <h4>&#9658; &nbsp; Innovation Made in Germany</h4>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                  <h4>&#9658; &nbsp; 40 Jahre Know-How</h4>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h4>&#9658; &nbsp; Deutscher Servicestützpunkt</h4>
              </Col>


            </Row>
          </Grid>
          <br/>
        </div>
        </section>
        <section>

        <Grid className="gridUp">
          <br/>
          <center>
          <h1>Produkte</h1>
          </center>
          <br/><br/>
          <Row className="show-grid">
            <Col  xs={12} sm={6}>
              <center>
                <div className="productsButton">
                  <Link to="/Suppliers/Exeron/EDM"><h4 className="buttonBlue">EDM</h4>
                    <h5>Unsere jahrzehntelange Erfahrung als Vorreiter in der Funkenerosion hat uns zum international anerkannten Erodiermaschinenhersteller werden lassen. Unsere Technik ist dabei allein an Ihren Bedürfnissen orientiert.</h5>
                    <p>Mehr ...</p>
                  </Link>
                </div>
            </center>
            </Col>
            <Col  xs={12} sm={6}>
              <center>
                <div className="productsButton">
                  <Link to="/Suppliers/Exeron/HSC"><h4 className="buttonBlue" >HSC</h4>
                <h5>Ob Drei- oder Fünf-Achs-Bearbeitung, kleine Einzelstücke oder Großserienfertigung: Unsere HSC Fräsmaschinen sind immer kompakt, wirtschaftlich in Anschaffung und Bearbeitung, hochpräzise sowie vielseitig einsetzbar. </h5>
              <p>Mehr ...</p>
            </Link>
            </div>
            </center>
            </Col>

          </Row>

        </Grid>
        <br/>
      </section>
      <hr/>
      <section>
        <br/>
        <center>
        <h1>News</h1>
        </center>
        <br/><br/>
        <center>
        <div className="newsAtSupplier" id="newsRoot"/>
        </center>
        <br/><br/><br/>
      </section>
        </div>
    );
  }
}

export default Exeron;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/exeron/mainPageSup.js